export enum MobilityAccountStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  INITIALIZED = 'INITIALIZED',
  TERMINATED = 'TERMINATED'
}
